var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgNotifications = function SvgNotifications(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.148 14.68c-.742-.82-2.187-2.032-2.187-6.055 0-3.008-2.11-5.43-5-6.055v-.82c0-.664-.547-1.25-1.211-1.25-.703 0-1.25.586-1.25 1.25v.82c-2.89.625-5 3.047-5 6.055 0 4.023-1.445 5.234-2.188 6.055-.234.234-.351.547-.312.82 0 .664.469 1.25 1.25 1.25h14.96c.782 0 1.25-.586 1.29-1.25 0-.273-.117-.586-.352-.82Zm-14.53.195c.82-1.055 1.718-2.89 1.757-6.21v-.04c0-2.383 1.953-4.375 4.375-4.375 2.383 0 4.375 1.992 4.375 4.375 0 .04-.04.04-.04.04.04 3.32.938 5.155 1.759 6.21H3.617ZM9.75 20.5c1.367 0 2.46-1.094 2.46-2.5H7.25c0 1.406 1.094 2.5 2.5 2.5Z",
    fill: "#4A4A68"
  })));
};

export default SvgNotifications;